<section class="app-page">
  <div class="px-12 py-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold">Technicians Dashboard</h1>
    </div>

    <!-- Placeholder Content -->
    <div class="card bg-base-100 shadow-sm border border-base-300">
      <div class="card-body">
        <div class="text-center py-12">
          <span class="text-6xl mb-4">🔧</span>
          <h2 class="text-xl font-semibold text-gray-700 mb-2">Technicians Dashboard</h2>
          <p class="text-gray-500">Dashboard features coming soon...</p>
        </div>
      </div>
    </div>
  </div>
</section>
